<mibi-box-layout>

<nav class="mibi-login">
    <div class="mibi-login__content">
        <a
            *ngIf="!isAlternativeWelcomePage; else disabledLink"
            class="mibi-link"
            (click)="onLogin()"
            style="cursor: pointer"
        >
            <div class="mibi-link__text">{{tab.name}}</div>
        </a>
        <ng-template #disabledLink>
            <a
                class="mibi-link-deactivated"
                [routerLink]="null"
            >
                <div class="mibi-link__text">{{tab.name}}</div>
            </a>
        </ng-template>
    </div>
</nav>

</mibi-box-layout>
